import moment from "moment";
import { useRef, useState } from "react";
import { controlToastState, Modal } from "risa-oasis-ui_v2";
import { runNycbsPharmaStatusTrackingByDateRange } from "../../../api/postCall/runNycbsPharmaStatusTracking";
import { ModalId } from "../../../enums/modalId";
import AsteraTrackStatusContent, {
  AsteraTrackStatusDateRange,
} from "../asteraTrackStatus/asteraTrackStatusContent";

interface PrimaryCareTrackStatusModalProps {
  onClose: () => void;
  onSuccess: () => void;
}

const PrimaryCareTrackStatusModal = (
  props: PrimaryCareTrackStatusModalProps,
) => {
  const { onClose, onSuccess } = props;
  const [isSaving, setIsSaving] = useState(false);
  const [dateRangeSelection, setDateRangeSelection] =
    useState<AsteraTrackStatusDateRange | null>(null);
  const closeTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const hasDateRangeSelection =
    dateRangeSelection?.startDate != null &&
    dateRangeSelection?.endDate != null;

  const handleSave = async () => {
    if (!dateRangeSelection?.startDate || !dateRangeSelection?.endDate) return;

    setIsSaving(true);
    try {
      const org_id = "Q0n3aZ2ZohYkn1SIrZsJ";
      const payload = {
        org_id,
        filters: {
          date_of_filing: {
            start_date: moment(dateRangeSelection.startDate).format(
              "MM/DD/YYYY",
            ),
            end_date: moment(dateRangeSelection.endDate).format("MM/DD/YYYY"),
          },
        },
      };

      runNycbsPharmaStatusTrackingByDateRange(payload).catch(() => {
        controlToastState("track-status-error");
      });

      closeTimeout.current = setTimeout(() => {
        closeTimeout.current = null;
        controlToastState("track-status-success");
        onSuccess();
      }, 5000);
    } catch {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    if (closeTimeout.current) {
      clearTimeout(closeTimeout.current);
      closeTimeout.current = null;
    }
    onClose();
  };

  return (
    <Modal
      dialogId={ModalId.PRIMARY_CARE_TRACK_STATUS_MODAL}
      title="Track Status"
      onClose={handleClose}
      onCancel={handleClose}
      onSave={isSaving ? () => {} : handleSave}
      saveButtonText={isSaving ? "Running..." : "Run Status"}
      disableSave={isSaving || !hasDateRangeSelection}
      cancelText="Cancel"
      heightPercentage={60}
      hideFooter={false}
    >
      <div className="flex h-full flex-col overflow-y-auto p-2">
        <AsteraTrackStatusContent
          showActions={false}
          onDateRangeChange={(hasSelection, dateRange) => {
            setDateRangeSelection(hasSelection && dateRange ? dateRange : null);
          }}
        />
      </div>
    </Modal>
  );
};

export default PrimaryCareTrackStatusModal;
